import { useEffect, useState } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Loader2 } from 'lucide-react'
import { SITE_URL } from '../../utils/seo.js'

export default function DynamicPage() {
  const { slug }  = useParams()
  const [page,    setPage]    = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(`/admin/api/public/pages/${encodeURIComponent(slug)}`)
      .then(r => r.ok ? r.json() : null)
      .then(setPage)
      .catch(() => setPage(null))
      .finally(() => setLoading(false))
  }, [slug])

  if (loading) return (
    <div className="flex items-center justify-center min-h-64">
      <Loader2 className="w-6 h-6 animate-spin text-primary" />
    </div>
  )

  if (!page) return <Navigate to="/404" replace />

  return (
    <>
      <Helmet>
        <title>{page.title}</title>
        <meta name="description" content={page.description} />
        <link rel="canonical" href={`${SITE_URL}/p/${page.slug}`} />
        <meta property="og:title"       content={page.title} />
        <meta property="og:description" content={page.description} />
      </Helmet>

      <div id="main-content" className="max-w-4xl mx-auto px-4 sm:px-6 pt-10 pb-16">

        {/* Badge */}
        {page.badge && (
          <div className="flex justify-center mb-6 animate-fade-in">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold border border-primary/20">
              {page.badge}
            </span>
          </div>
        )}

        {/* Heading */}
        <h1 className="text-3xl sm:text-5xl font-bold text-center leading-tight tracking-tight mb-4 animate-fade-in-up">
          {page.h1}{' '}
          {page.h2 && <span className="text-gradient">{page.h2}</span>}
        </h1>

        {/* Subheading */}
        {page.subheading && (
          <p className="text-base sm:text-lg text-muted-foreground text-center max-w-2xl mx-auto leading-relaxed mb-10 animate-fade-in-up">
            {page.subheading}
          </p>
        )}

        {/* Content */}
        {page.content && (
          <div
            className="prose prose-sm sm:prose-base dark:prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: page.content }}
          />
        )}
      </div>
    </>
  )
}
